<template>
  <b-card
    overlay
    :img-src="img_src"
    :img-alt="getSafe(() => device.object)"
    text-variant="white"
    :title="getSafe(() => device.object)"
    :sub-title="lastTimeMessage"
    ref="camera-display"
  >
    <div style="background-color=#000 !important;">
      <b-card-text>
        <div class="text-center">
          <b-spinner
            variant="light"
            label="Loading..."
            style="invert(1);"
            v-if="lastTimeLoaded == -1"
          ></b-spinner>
        </div>
      </b-card-text>
    </div>
  </b-card>
</template>

<script>
import { CAMERA_LATEST_META } from "@/core/services/store/devices.module";

export default {
  name: "suitch-image-widget",
  components: {},
  props: {
    device: null,
  },
  mounted() {
    // Poll a cheap meta endpoint (mtime/size of latest.jpg). We only reload the
    // image and advance the "x ago" counter when the mtime actually changes, so
    // the counter reflects real new frames — not how often we polled.
    this.startPolling();
    this.clockTimer = setInterval(() => {
      if (this.lastTimeLoaded == -1) {
        this.lastTimeMessage = "loading ...";
        return;
      }
      const elapsed_seconds = Math.ceil((Date.now() - this.lastTimeLoaded) / 1000);
      if (elapsed_seconds < 60) {
        this.lastTimeMessage = String(elapsed_seconds) + " seconds ago";
      } else {
        this.lastTimeMessage = String(Math.floor(elapsed_seconds / 60)) + " minutes ago";
      }
    }, 1000);
  },
  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer);
    if (this.clockTimer) clearInterval(this.clockTimer);
  },
  data() {
    return {
      pollTimer: null,
      clockTimer: null,
      current_device: { connection_type: -1 },
      img_src: "media/bg/camera-blank.jpg",
      lastTimeLoaded: -1,
      lastTimeMessage: "loading ...",
      lastMtime: null, // mtime of the frame currently shown
      pollMs: 300, // how often we check for a new frame (cheap JSON)
    };
  },
  methods: {
    getSafe,
    startPolling() {
      this.pollTimer = setInterval(this.pollMeta, this.pollMs);
      this.pollMeta();
    },
    pollMeta() {
      const token = this.getSafe(() => this.device.token);
      if (token == null) return;
      this.$store
        .dispatch(CAMERA_LATEST_META, { token })
        .then((data) => {
          if (!data || !data.exists) return;
          // only a changed mtime means a genuinely new frame
          if (data.mtime !== this.lastMtime) {
            this.lastMtime = data.mtime;
            // cache-bust by mtime: unchanged frame stays cached (no re-download),
            // a new frame gets a new URL and is fetched
            this.img_src =
              "https://suitch.network/recordings/" + token + "/latest.jpg?t=" + data.mtime;
            this.lastTimeLoaded = Date.now();
          }
        })
        .catch(() => {
          // camera offline / no frame yet: keep the last image, counter keeps growing
        });
    },
  },
  watch: {
    device: function(oldval, newval) {
      oldval, newval;
    },
  },
};
function getSafe(fn) {
  try {
    return fn();
  } catch (e) {
    // happy
  }
}
</script>
